import {useMemo} from "react";

import {useCountSearchFilters} from "../../../search/hooks/use_count_search_filters";
import {SearchFormValuesType} from "../../../search/types/SearchFormValuesType";
import {getSearchFiltersByOfferType} from "../../../search/utils/get_search_filters_by_offer_type";

type FormValuesType = Pick<SearchFormValuesType, "type" | "price" | "rooms">;

export const useNotificationsFilters = (formValues: FormValuesType) => {
    const searchFiltersConfig = useMemo(() => getSearchFiltersByOfferType("notification"), [formValues]);
    const {countBySlots, totalCount} = useCountSearchFilters(formValues, searchFiltersConfig);

    return {
        searchFiltersConfig,
        countBySlots,
        totalCount
    };
};
import {useMemo} from "react";

import {useCountSearchFilters} from "../../../search/hooks/use_count_search_filters";
import {SearchFormValuesType} from "../../../search/types/SearchFormValuesType";
import {getSearchFiltersByOfferType} from "../../../search/utils/get_search_filters_by_offer_type";

type FormValuesType = Pick<SearchFormValuesType, "type" | "price" | "rooms">;

export const useNotificationsFilters = (formValues: FormValuesType) => {
    const searchFiltersConfig = useMemo(() => getSearchFiltersByOfferType("notification"), [formValues]);
    const {countBySlots, totalCount} = useCountSearchFilters(formValues, searchFiltersConfig);

    return {
        searchFiltersConfig,
        countBySlots,
        totalCount
    };
};
